import cx from "classnames"

export interface CornerRibbonProps {
  text: string
  size?: "sm" | "lg"
  dark?: boolean
}

const CornerRibbon = ({
  text,
  size = "sm",
  dark = false,
}: CornerRibbonProps) => (
  <div
    className={cx(
      "absolute right-0 top-0 overflow-hidden pointer-events-none",
      {
        "w-[140px] h-[140px]": size === "sm",
        "w-[160px] h-[160px]": size === "lg",
      }
    )}
  >
    <p
      className={cx(
        "absolute transform rotate-45",
        "text-white text-lg text-center font-body leading-[22px] tracking-[0.02em] py-3",
        {
          "bg-leaf": !dark,
          "bg-charcoal-900": dark,
          "w-[198px] top-[30px] -right-[45px]": size === "sm",
          "w-[226px] top-[41px] -right-[49px]": size === "lg",
        }
      )}
    >
      {text}
    </p>
  </div>
)

export default CornerRibbon
